export const mapSearchPublicationToProps = ({ hit, isFavorite, onClick }) => {
    const id = parseInt(hit.objectID.split('-')[1], 10);
    return {
        id,
        title: hit.title,
        url: `${window.location.protocol}//${window.location.hostname}${hit.url}`,
        image: hit.image,
        createdAt: hit.created_at,
        description: hit.description,
        formats: hit.formats,
        languages: hit.languages,
        topics: hit.topics,
        isFavorite,
        onClick,
    };
};

export const mapGraphPublicationToProps = publication => ({
    id: publication.recordId,
    title: publication.title,
    url: `${window.location.protocol}//${window.location.hostname}${publication.url}`,
    image: publication.image,
    createdAt: publication.created_at,
    description: publication.description,
    formats: publication.formats,
    languages: publication.languages,
    topics: publication.topics,
    isFavorite: true,
});
